import React, { useState } from 'react';
import { Box, Grid, IconButton, FormControl, InputLabel, FormHelperText } from '@mui/material';
import Field from '../../../components/field';
import deleteIcon from '../../../styles/svg/delete-icon.svg';

const SelectedFilesList = ({ files, onTitleChange, onRemoveFile, formMethods }) => {
  const [errors, setErrors] = useState({});
  
  if (!files || files.length === 0) {
    return null;
  }
  
  const validateTitle = (id, value) => {
    if (!value || value.trim() === '') {
      setErrors(prev => ({
        ...prev,
        [id]: 'Document title is required'
      }));
      
      // Update React Hook Form validation state if available
      if (formMethods) {
        formMethods.setError(`documentTitles.${id}`, {
          type: 'required',
          message: 'Document title is required'
        });
      }
      
      return false;
    } else {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[id];
        return newErrors;
      });
      
      // Clear React Hook Form error if available
      if (formMethods) {
        formMethods.clearErrors(`documentTitles.${id}`);
      }
      
      return true;
    }
  };
  
  const handleTitleChange = (id, value) => {
    validateTitle(id, value);
    onTitleChange(id, value);
  };

  return (
    <Grid item xs={12}>
      <p className="text-heading-regular">Selected Files</p>
      <Box className="selected-file-list-container">
        {files.map((fileObj) => (
          <Box 
            key={fileObj.id}
            className="selected-file-list-item"
          >
            <Box className="file-info">
              <Box className="file-info-box">
                <FormControl fullWidth variant="outlined">
                  <InputLabel shrink htmlFor={`document-title-${fileObj.id}`}>
                    Document Title
                  </InputLabel>
                  <Field
                    id={`document-title-${fileObj.id}`}
                    value={fileObj.title}
                    onChange={(e) => handleTitleChange(fileObj.id, e.target.value)}
                    onBlur={() => validateTitle(fileObj.id, fileObj.title)}
                    required
                    fullWidth
                    defaultValue={fileObj.title}
                    placeholder="Enter document title"
                    error={!!errors[fileObj.id]}
                  />
                  {errors[fileObj.id] && (
                    <FormHelperText error sx={{ ml: 0 }}>
                      {errors[fileObj.id]}
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl fullWidth variant="outlined" sx={{ ml: 2 }}>
                  <InputLabel shrink htmlFor={`file-name-${fileObj.id}`}>
                    File
                  </InputLabel>
                  <Field
                    id={`file-name-${fileObj.id}`}
                    placeholder={fileObj.file.name }
                    disabled
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </FormControl>
              </Box>
            </Box>
            <Box>
              <IconButton onClick={() => onRemoveFile(fileObj.id)} color="error" size="small">
               <img src={deleteIcon} alt="delete" />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>
    </Grid>
  );
};

export default SelectedFilesList;
